// extracted by mini-css-extract-plugin
export var bottomCloud = "PhotoGalleryModule-module--bottomCloud--31769";
export var contentContainer = "PhotoGalleryModule-module--contentContainer--88bbe";
export var gallery = "PhotoGalleryModule-module--gallery--41579";
export var galleryContainer = "PhotoGalleryModule-module--galleryContainer--6d7fc";
export var logoContainer = "PhotoGalleryModule-module--logoContainer--bdfc2";
export var logosContainer = "PhotoGalleryModule-module--logosContainer--0313c";
export var scrollingContainer = "PhotoGalleryModule-module--scrollingContainer--dfed9";
export var scrollingWrapper = "PhotoGalleryModule-module--scrollingWrapper--3b141";
export var title = "PhotoGalleryModule-module--title--3eece";
export var titleContainer = "PhotoGalleryModule-module--titleContainer--0b60e";
export var topCloud = "PhotoGalleryModule-module--topCloud--303af";